<template>
  <div class="page-container">
    <el-card class="card-top" shadow="hover">
      <div class="card-actions">
        <el-button type="primary" @click="showCreateDialog = true">新增区域</el-button>
      </div>
    </el-card>
    <el-card class="card-table" shadow="hover">
      <el-table :data="regions" border stripe style="width: 100%;" size="small" height="500px">
        <el-table-column prop="name" label="区域名称" align="center" />
        <el-table-column prop="description" label="区域描述" align="center" />
        <el-table-column prop="createdAt" label="创建时间" align="center" />
        <el-table-column label="操作" align="center" width="160">
          <template slot-scope="scope">
            <!-- <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button> -->
            <el-button type="text" style="color: #F56C6C" size="small" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <!-- 新增/编辑对话框 -->
    <el-dialog :title="editMode ? '编辑区域' : '新增区域'" :visible.sync="showCreateDialog" width="400px" @close="resetForm">
      <el-form :model="form" :rules="formRules" ref="regionForm" label-width="80px">
        <el-form-item label="区域名称" prop="name">
          <el-input v-model="form.name" autocomplete="off" />
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input v-model="form.description" autocomplete="off" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showCreateDialog = false">取 消</el-button>
        <el-button type="primary" :loading="formLoading" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'RegionManage',
  data() {
    return {
      regions: [],
      showCreateDialog: false,
      editMode: false,
      form: {
        id: '',
        name: '',
        description: ''
      },
      formLoading: false,
      formRules: {
        name: [
          { required: true, message: '请输入区域名称', trigger: 'blur' }
        ],
        description: [
          { required: true, message: '请输入描述', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    fetchRegions() {
      axios.get('/api/regions').then(res => {
        this.regions = res.data || []
      })
    },
    handleEdit(row) {
      this.editMode = true
      this.form = { id: row.id, name: row.name, description: row.description }
      this.showCreateDialog = true
    },
    handleDelete(row) {
      this.$confirm('确认删除该区域?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const res = await axios.delete(`/api/regions/${row.id}`)
          if (res.data && res.data.code && res.data.code !== 200) {
            this.$message.error(res.data.message || '删除失败')
          } else {
            this.$message.success('删除成功')
            this.fetchRegions()
          }
        } catch (e) {
          this.$message.error((e.response && e.response.data && e.response.data.message) ? e.response.data.message : '删除失败')
        }
      })
    },
    handleSubmit() {
      this.$refs.regionForm.validate(async valid => {
        if (!valid) return
        this.formLoading = true
        try {
          if (this.editMode) {
            const res = await axios.put(`/api/regions/${this.form.id}`, { name: this.form.name, description: this.form.description })
            if (res.data && res.data.code && res.data.code !== 200) {
              this.$message.error(res.data.message || '编辑失败')
            } else {
              this.$message.success('编辑成功')
              this.showCreateDialog = false
              this.fetchRegions()
            }
          } else {
            const res = await axios.post('/api/regions', { name: this.form.name, description: this.form.description })
            if (res.data && res.data.code && res.data.code !== 200) {
              this.$message.error(res.data.message || '新增失败')
            } else {
              this.$message.success('新增成功')
              this.showCreateDialog = false
              this.fetchRegions()
            }
          }
        } catch (e) {
          this.$message.error((e.response && e.response.data && e.response.data.message) ? e.response.data.message : (this.editMode ? '编辑失败' : '新增失败'))
        } finally {
          this.formLoading = false
        }
      })
    },
    resetForm() {
      this.editMode = false
      this.form = { id: '', name: '', description: '' }
      if (this.$refs.regionForm) this.$refs.regionForm.resetFields()
    }
  },
  mounted() {
    this.fetchRegions()
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  padding: 24px 18px 0 18px;
  background: #f6f8fa;
  min-height: 100%;
}
.card-top {
  margin-bottom: 18px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}
.card-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}
.card-table {
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}
.el-table {
  font-size: 15px;
  border-radius: 6px;
  overflow: hidden;
}
</style> 